import React from "react";
import PropTypes from "prop-types";
import { consumeContext } from "../VideoSettingsContext";

var Form = function Form(_ref) {
  var VideoSettingsContext = _ref.VideoSettingsContext;
  var state = VideoSettingsContext.state,
      setVideoTitle = VideoSettingsContext.setVideoTitle,
      setVideoCaption = VideoSettingsContext.setVideoCaption;
  var videoTitle = state.videoTitle,
      videoCaption = state.videoCaption;
  var fields = [{
    value: videoTitle || "",
    label: "Video title",
    changeHandler: function changeHandler(e) {
      return setVideoTitle(e.target.value);
    }
    /*{
      value: videoCaption || "",
      label: "Video caption",
      changeHandler: e => setVideoCaption(e.target.value)
    }*/

  }];
  return React.createElement("div", {
    className: "recorder__form-left"
  }, fields.map(function (_ref2) {
    var value = _ref2.value,
        label = _ref2.label,
        changeHandler = _ref2.changeHandler;
    return React.createElement("div", {
      key: label,
      className: "form form--style-account"
    }, React.createElement("label", {
      className: "form__label"
    }, label), React.createElement("div", {
      className: "form__container"
    }, React.createElement("input", {
      type: "text",
      className: "form__input",
      placeholder: label,
      value: value,
      onChange: changeHandler
    })));
  }));
};

Form.propTypes = process.env.NODE_ENV !== "production" ? {
  VideoSettingsContext: PropTypes.object.isRequired
} : {};
export default consumeContext(Form);